import React, { useEffect, useState } from 'react';
/* eslint-disable camelcase,@typescript-eslint/camelcase */
import { useDispatch, useSelector } from 'react-redux';
import * as R from 'ramda';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import uuidv4 from 'uuid/v4';
import { useTranslation } from 'react-i18next';

import { getClientCode } from 'reducers/Login';
import { getSelectedPosID } from 'reducers/PointsOfSale';
import { sendEventsToSSE } from 'services/GoErp/SendEventsToSSE';
import { RootState } from 'reducers';
import { openWindowOnSelectedScreen } from 'plugins/customerDisplay/rdx/actions';
import { getChannelName, getChannelPasscode } from 'plugins/customerDisplay';
import { HeaderIconButton } from 'containers/Header/components/Icon';
import Icon from 'components/Icon';
import { getEndpointForService } from 'reducers/configs/serviceEnpoints';
import ScreenSelectMenu from 'plugins/customerDisplay/screenSelect/ScreenSelectMenu';
import { PosPlugin } from 'plugins/plugin';
import { Configuration } from 'plugins/customerDisplay/types';

import { generatePayload } from '../utils';

const useUpdateCustomerDisplayState = () => {
  const dispatch: ThunkDispatch<RootState, unknown, Action> = useDispatch();
  const [payload, setPayload] = useState('""');

  dispatch(generatePayload()).then(resp => {
    setPayload(resp);
  });

  return {
    payload,
  };
};
const ComponentHeader: PosPlugin<Configuration>['ComponentHeader'] = () => {
  const clientCode = useSelector(getClientCode);
  const posId = useSelector(getSelectedPosID);
  const dispatch: ThunkDispatch<RootState, unknown, Action> = useDispatch();
  const channelName = useSelector(getChannelName);
  const passCode = useSelector(getChannelPasscode);
  const { t } = useTranslation('plugin-customerDisplay');
  const { url: apiEndpoint } = getEndpointForService('goerp');

  const displayUrl = `${apiEndpoint.replace(
    '/api/',
    '/public/',
  )}${clientCode}/en/goerp-pos-cd-page?po=${posId}&pa=${passCode}`;

  const { payload } = useUpdateCustomerDisplayState();

  useEffect(() => {
    const action = `update-customer-display-${clientCode}-${posId}`;
    const parsed = JSON.parse(payload);

    // Add cartId here to guarantee uniqueness, but not to cause the `payload` to endlessly change
    const dataToSend = R.assocPath(['getCart', 'cartId'], uuidv4())(parsed);
    sendEventsToSSE(action, dataToSend);
  }, [clientCode, payload, posId]);

  const openCustomerDisplay = async () => {
    await dispatch(openWindowOnSelectedScreen(displayUrl));
  };

  return (
    <>
      <HeaderIconButton
        onClick={channelName ? openCustomerDisplay : undefined}
        size="small"
      >
        <Icon
          name="icon_desktop"
          style={{ color: channelName ? 'lightgreen' : 'salmon' }}
          title={
            channelName ? t('header.titleOK') : t('header.titleMissingChannel')
          }
        />
      </HeaderIconButton>
      <ScreenSelectMenu />
    </>
  );
};

export default ComponentHeader;
